interface DataPoint {
  label: string;
  value: number;
}

interface SimpleBarChartProps {
  data: DataPoint[];
  title?: string;
  color?: string;
  height?: number;
  showValues?: boolean;
}

export default function SimpleBarChart({
  data,
  title,
  color = '#D4AF37',
  height = 200,
  showValues = true,
}: SimpleBarChartProps) {
  if (data.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No data available
      </div>
    );
  }

  const maxValue = Math.max(...data.map((d) => d.value), 1);

  return (
    <div>
      {title && (
        <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      )}
      <div className="flex items-end justify-between gap-2" style={{ height }}>
        {data.map((item, index) => {
          const barHeight = (item.value / maxValue) * 100;

          return (
            <div
              key={index}
              className="flex-1 flex flex-col items-center justify-end"
            >
              {showValues && (
                <span className="text-sm text-gray-500 mb-1">
                  {item.value}
                </span>
              )}
              <div
                className="w-full rounded-t-md transition-all duration-300 hover:opacity-80"
                style={{
                  backgroundColor: color,
                  height: `${barHeight}%`,
                  minHeight: item.value > 0 ? 4 : 0,
                }}
                title={`${item.label}: ${item.value}`}
              />
              <span className="text-xs text-gray-500 mt-2 truncate w-full text-center">
                {item.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
